class Accordion {
    constructor(elem, accordeonParent) {
        this.parent = elem;
        this.button = elem.querySelector("[data-accordeon-label]");
        this.content = elem.querySelector("[data-accordeon-content]");
        this.accordeonParent = accordeonParent;
        this.imageSource = this.button.getAttribute("data-image-source");
        this.imageAlt = this.button.getAttribute("data-image-alt");
        this.imageDesktop = this.accordeonParent.parentElement.querySelector(
            ".markets__item__media--desktop > img",
        );
    }

    init() {
        this.button.addEventListener("click", (evt) => {
            this.toggleAccordion(this.parent);
        });
    }

    toggleAccordion(elem) {
        if (elem.classList.contains("is-open")) {
            //this.closeContent(elem);
        } else {
            // on close all other accordeons
            const othersAccordeons =
                this.accordeonParent.querySelectorAll("[data-accordeon]");
            if (othersAccordeons) {
                othersAccordeons.forEach((otherAccordeon) => {
                    if (otherAccordeon !== elem) {
                        this.closeContent(otherAccordeon);
                    }
                });
            }

            this.openContent(elem);
        }
    }

    openContent(content) {
        content.classList.add("is-open");

        this.imageDesktop.src = this.imageSource;
        this.imageDesktop.alt = this.imageAlt;
    }

    closeContent(content) {
        content.classList.remove("is-open");
    }
}

const accordionMarket = document.querySelectorAll("[data-accordeon-market]");
if (accordionMarket) {
    accordionMarket.forEach((accordeonParent) => {
        const allAccordion =
            accordeonParent.querySelectorAll("[data-accordeon]");
        allAccordion.forEach((item) => {
            const accordeon = new Accordion(item, accordeonParent);
            accordeon.init();
        });
    });
}
